import { Box } from '@inflearn/ds-react-next';
import { ASSETS } from '../../../../constants/redLightGreenLightConfig';
import { watcherStyle } from './styles';
import type { RedLightGameWatcherProps } from './types';

export const RedLightGameWatcher = ({
  x,
  y,
  watcherState,
  redStateDuration,
  blinkState,
}: RedLightGameWatcherProps) => {
  const getWatcherSprite = () => {
    switch (watcherState) {
      case 'green':
        return ASSETS.watcher.green;
      case 'peeking':
        return ASSETS.watcher.peeking;
      case 'sleeping':
        return ASSETS.watcher.sleeping;
      case 'turning':
        return ASSETS.watcher.turning;
      case 'red':
        // Blink between two images if red state duration > 1 second
        if (redStateDuration >= 1000) {
          return blinkState ? ASSETS.watcher.red : ASSETS.watcher.turning;
        }
        return ASSETS.watcher.red;
      default:
        return ASSETS.watcher.green;
    }
  };

  return (
    <Box
      css={watcherStyle(x, y, watcherState)}
      style={{
        backgroundImage: `url(${getWatcherSprite()})`,
      }}
    />
  );
};
